module.exports = __webpack_public_path__ + "static/img/morning.2665d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/timelog/morning.png
// module id = Cagy
// module chunks = 0